export const MAINTENANCE_BANNER_EN = {
  maintenanceBanner: {
    title: 'Scheduled maintenance',
    description:
      'From Friday, 09.10.2026 at 11:00 PM until Monday, 12.10.2026 at 7:00 AM, Newsrooms AI will undergo maintenance. During this time newsrooms.ai will not be available.',
    dismiss: 'Dismiss notice'
  }
}

export const MAINTENANCE_BANNER_DE = {
  maintenanceBanner: {
    title: 'Geplante Wartungsarbeiten',
    description:
      'Von Freitag, 09.10.2026, 23:00 Uhr bis Montag, 12.10.2026, 07:00 Uhr führen wir Wartungsarbeiten an Newsrooms AI durch. In diesem Zeitraum ist newsrooms.ai nicht erreichbar.',
    dismiss: 'Hinweis schließen'
  }
}
